<ng-container *ngIf="documents?.length > 0">
  <p>Test Documents</p>
  <div class="test-document-container">
    <app-document-viewer
      *ngFor="let doc of documents"
      [src]="src(doc.location)"
      viewer="microsoft"
    ></app-document-viewer>
  </div>
</ng-container>

<ng-container *ngIf="testImages?.length > 0">
  <p>Test Images</p>
  <app-image-viewer [images]="testImages"></app-image-viewer>
</ng-container>

<!-- by-phantom layouts: one gallery per group; otherwise one per series -->
<ng-container *ngIf="groupGalleries; else perSeries">
  <ng-container *ngFor="let gallery of groupGalleries">
    <p>
      {{ gallery.title
      }}<span *ngIf="gallery.images.length === 0"> (no images)</span>
    </p>
    <app-image-viewer
      *ngIf="gallery.images.length > 0"
      [images]="gallery.images"
      [dcmKeys]="gallery.dcmKeys"
    ></app-image-viewer>
  </ng-container>
</ng-container>
<ng-template #perSeries>
  <ng-container *ngIf="result.series">
    <ng-container *ngFor="let series of result.series; let i = index">
      <p>Series {{ i + 1 }}</p>
      <app-image-viewer
        [images]="seriesImages[i]"
        [dcmKeys]="seriesDcmKeys && seriesDcmKeys[i]"
      ></app-image-viewer>
    </ng-container>
  </ng-container>
</ng-template>
